export default "__VITE_ASSET__b7x69WGD__"